import React from "react";
import { observer } from "mobx-react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  withStyles
} from "@material-ui/core";
import { Classes, ThemeType } from "@theme";
import RegularButton from "@components/buttons/RegularButton";

import { VirtualSelectorStore } from "./VirtualSelectorStore";
import VirtualSelectorSearchResult from "./VirtualSelectorSearchResult";
import { SearchItem } from "./utils";
import locale from "@bonliva-crm/locale";
import PrimaryButton from "@common/buttons/PrimaryButton";

type Props<FILTER extends {}, SEARCH_ITEM extends SearchItem> = {
  classes: Classes<typeof styles>;
  renderFilter: () => React.ReactNode;
  onShowSelected?: () => void;
  renderItem: (item: SEARCH_ITEM, selected: boolean) => React.ReactNode;
  store: VirtualSelectorStore<FILTER, SEARCH_ITEM, any>;
  title?: string;
  waitingContent?: React.ReactNode;
};

@observer
class VirtualSelectorSearchDialog<
  FILTER extends {},
  SEARCH_ITEM extends SearchItem
> extends React.Component<Props<FILTER, SEARCH_ITEM>> {
  render() {
    const { classes, store, title } = this.props;

    return (
      <Dialog
        classes={{ paper: classes.paperRoot }}
        open={store.isSearchOpen}
        onClose={store.closeSearchDialog}
        fullWidth
        maxWidth="md"
      >
        {title && <DialogTitle>{title}</DialogTitle>}

        <DialogContent style={{ display: "flex", overflowY: "hidden" }}>
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            {this.props.renderFilter()}
            {this.renderList()}
          </div>
        </DialogContent>

        <DialogActions>
          <RegularButton onClick={store.closeSearchDialog}>{locale.Cancel}</RegularButton>

          {store.props.multi && (store.selected.length > 0 || store.showSelected) && (
            <RegularButton
              onClick={
                this.props.onShowSelected
                  ? this.props.onShowSelected
                  : store.handleShowSelected
              }
            >
              {locale.ShowSelected} ({store.selected.length})
            </RegularButton>
          )}

          {store.props.multi && (
            <PrimaryButton onClick={() => store.selectMultiple()}>
              {locale.OK}
            </PrimaryButton>
          )}
        </DialogActions>
      </Dialog>
    );
  }

  private renderList = () => {
    const { classes, store, renderItem } = this.props;
    // TODO upd consultant and accommodation selectors(add query selected item _id) and remove next condition rendering
    if (store.showSelected) {
      return (
        <div style={{ overflow: "auto" }}>
          {store.selectedCustomerItem.map((s) => (
            <div key={s._id} className={classes.selectedItem}>
              {renderItem(s, true)}
            </div>
          ))}
        </div>
      );
    }
    return (
      <div className={classes.resultsWrapper}>
        <VirtualSelectorSearchResult
          store={store}
          renderItem={renderItem}
          waitingContent={this.props.waitingContent}
        />
      </div>
    );
  };
}

const styles = (theme: ThemeType) => ({
  paperRoot: {
    height: "calc(100% - 96px)"
  },
  selectedItem: {
    marginTop: theme.spacing()
  },

  resultsWrapper: {
    display: "flex",
    flex: 1,
    overflowY: "hidden"
  }
});

export default withStyles(styles as any)(VirtualSelectorSearchDialog);
